import { useState, useCallback } from 'react';

/**
 * Production-grade hook to manage Terms & Conditions acceptance.
 * Centralizing this state allows it to be shared across multiple payment methods.
 */
export function useCheckoutTerms() {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsError, setShowTermsError] = useState(false);

  const validateTerms = useCallback(() => {
    if (!termsAccepted) {
      setShowTermsError(true);
      return false;
    }
    setShowTermsError(false);
    return true;
  }, [termsAccepted]);

  return {
    termsAccepted,
    setTermsAccepted,
    showTermsError,
    setShowTermsError,
    validateTerms,
  };
}
